import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { QueryParams } from 'renderer/shared/schemas/common.schemas';

type UsersTableState = QueryParams;

const initialState: UsersTableState = {
  page: 1,
  limit: 10,
  sortBy: 'createdAt',
  sortOrder: 'desc',
  search: '',
};

const resetReducer: CaseReducer<UsersTableState> = () => {
  return initialState;
};

export const usersTableSlice = createSlice({
  name: 'usersTable',
  initialState: initialState as UsersTableState,
  reducers: {
    resetUsersTable: resetReducer,
    setUsersTableQuery: (state, { payload }: PayloadAction<QueryParams>) => {
      return payload;
    },
    setUsersTablePageNumber: (state, { payload }: PayloadAction<number>) => {
      state.page = payload;
    },
    setUsersTableLimit: (state, { payload }: PayloadAction<number>) => {
      state.limit = payload;
    },
    setUsersTableSortBy: (state, { payload }: PayloadAction<string>) => {
      state.sortBy = payload;
    },
    setUsersTableSortOrder: (
      state,
      { payload }: PayloadAction<'desc' | 'asc'>,
    ) => {
      state.sortOrder = payload;
    },
    setUsersTableSearch: (state, { payload }: PayloadAction<string>) => {
      state.search = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  resetUsersTable,
  setUsersTableQuery,
  setUsersTablePageNumber,
  setUsersTableLimit,
  setUsersTableSortBy,
  setUsersTableSearch,
  setUsersTableSortOrder,
} = usersTableSlice.actions;

export default usersTableSlice.reducer;
